import React from 'react';
import './header-style.css';

const Header = () => {
  return (
    <div className='header'>
      <h1>School Finder</h1>
    </div>
  )
}

export default Header;



/** WEBPACK FOOTER **
 ** ./src/components/Header/index.js
 **/